import React from "react";
import { Facebook, Twitter, Instagram, Linkedin, Mail, MapPin } from 'lucide-react';
import TrripLogo from '../assets/Trrip_logo/trrip_logo.png';

const Footer = () => (
  <footer className="bg-primary text-white pt-12 pb-6 mt-auto">
    <div className="max-w-7xl mx-auto px-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">

        {/* Brand Section */}
        <div className="space-y-4">
          <div className="flex items-center gap-2">
            <img
              src={TrripLogo}
              alt="Trrip Logo"
              className="h-16 w-auto object-contain brightness-0 invert"
            />
          </div>
          <p className="text-brand-light text-sm leading-relaxed max-w-xs text-white/80">
            Empowering partners with cutting-edge tools to provide unforgettable experiences for travelers worldwide.
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h4 className="text-lg font-semibold mb-4">Company</h4>
          <ul className="space-y-2 text-sm text-brand-light">
            <li><a href="#" className="hover:text-white transition-colors text-white/80">About Us</a></li>
            <li><a href="#" className="hover:text-white transition-colors text-white/80">Careers</a></li>
            <li><a href="#" className="hover:text-white transition-colors text-white/80">Blog</a></li>
            <li><a href="#" className="hover:text-white transition-colors text-white/80">Press</a></li>
          </ul>
        </div>

        {/* Support */}
        <div>
          <h4 className="text-lg font-semibold mb-4">Support</h4>
          <ul className="space-y-2 text-sm text-brand-light">
            <li><a href="#" className="hover:text-white transition-colors text-white/80">Help Center</a></li>
            <li><a href="#" className="hover:text-white transition-colors text-white/80">Terms of Service</a></li>
            <li><a href="/privacy" className="hover:text-white transition-colors text-white/80">Privacy Policy</a></li>
            <li><a href="#" className="hover:text-white transition-colors text-white/80">Contact Us</a></li>
          </ul>
        </div>

        {/* Contact Info */}
        <div>
          <h4 className="text-lg font-semibold mb-4">Contact</h4>
          <div className="space-y-3 text-sm text-brand-light">
            <div className="flex items-start gap-3 text-white/80">
              <MapPin size={16} className="mt-1 flex-shrink-0" />
              <span>Shop no. 3, Gokul Plaza, Veer Savarkar Road, Virar East, 401303</span>
            </div>
            <div className="flex items-center gap-3 text-white/80">
              <Mail size={16} className="flex-shrink-0" />
              <span>support@trip.com</span>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-white/20 pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
        <p className="text-xs text-brand-light text-white/60">
          © 2025 ORBITRA TECHNOLOGIES LLP. All rights reserved.
        </p>
        <div className="flex gap-4">
          <a href="#" className="p-2 bg-white/10 rounded-full hover:bg-white/20 transition-all text-white">
            <Facebook size={16} />
          </a>
          <a href="#" className="p-2 bg-white/10 rounded-full hover:bg-white/20 transition-all text-white">
            <Twitter size={16} />
          </a>
          <a href="https://www.instagram.com/trrip_live?utm_source=ig_web_button_share_sheet&igsi=ZDNlZDc0MzIxNw==" target="_blank" rel="noopener noreferrer" className="p-2 bg-white/10 rounded-full hover:bg-white/20 transition-all text-white">
            <Instagram size={16} />
          </a>
          <a href="#" className="p-2 bg-white/10 rounded-full hover:bg-white/20 transition-all text-white">
            <Linkedin size={16} />
          </a>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
